import { render } from "./TabOrderList.vue?vue&type=template&id=76dbee75"
import script from "./TabOrderList.js?vue&type=script&lang=js"
export * from "./TabOrderList.js?vue&type=script&lang=js"

import "./TabOrderList.scss?vue&type=style&index=0&lang=scss"
/* custom blocks */
import block0 from "./TabOrderList.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FUser%2FTabOrderList%2FTabOrderList.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__